/**
 * Slider functionality
 *
 * @description This file includes the required functionality for the sliders used in several ACF blocks
 *
 * @return void
 * @access public
 *
 */

/**
 * Fizzy UI Utils
 */
import fizzyUIUtils from 'fizzy-ui-utils';
import matchesSelector from 'desandro-matches-selector/matches-selector';

/**
 * Import Flickity Slider custom functionality which is used
 * to slide with ease any element having specific classes
 */
const flickitySlideshow = require( './flickity-slideshow' );
const Flickity          = require( 'flickity' );

import {viewportWidth} from './helpers';

export const slider = () => {
	const evidenceSlider = document.querySelector( '.js-evidence-slider' );
	const imageSlider    = document.querySelector( '.js-image-slider' );
	const expertsSlider  = document.querySelector( '.js-experts-slider' );
	const stepCards      = document.querySelector( '.js-step-cards' );
	const utils          = fizzyUIUtils;

	const flickityGeneralOptions = {
		autoplay: true,
		imagesLoaded: true,
		percentPosition: true,
		draggable: true,
		wrapAround: false,
		pageDots: false,
		initialIndex: 0,
		prevNextButtons: false
	}

	const flickityGeneralOptionsTwo = {
		autoPlay: true,
		imagesLoaded: true,
		pageDots: false,
		wrapAround: true,
		prevNextButtons: false
	}



	/**
	 * Check if expertsSlider exists on the DOM and then
	 * run the flickity Slider with custom options
	 *
	 * @return void
	 * @since  1.0.0
	 * @access public
	 */

	document.addEventListener( 'DOMContentLoaded', function () {

		if ( evidenceSlider ) {
			const flktyEvidenceSlider = new Flickity( evidenceSlider, flickityGeneralOptionsTwo );
			flickitySegmentIntegration( flktyEvidenceSlider, evidenceSlider, true );
		}


		if ( expertsSlider && viewportWidth >= 768 ) {
			const flktyExpertsSlider = new Flickity( expertsSlider, flickityGeneralOptionsTwo );
			flickitySegmentIntegration( flktyExpertsSlider, expertsSlider, true )
		}

		if ( stepCards && viewportWidth < 992 ) {
			const flktyHiringSteps = new Flickity( stepCards, flickityGeneralOptions );
			flickitySegmentIntegration( flktyHiringSteps, stepCards, false )
		}

		// element argument can be a selector string
		// for an individual element
		if ( imageSlider ) {
			const flktyImageSlider = new Flickity( imageSlider, flickityGeneralOptionsTwo );
			flickitySegmentIntegration( flktyImageSlider, imageSlider, false )
		}

	});


	/*
	* Flickity - Segment Integration
	*
	* @since  1.0.0
	* @access public
	* @return void
	*
	*/
	function flickitySegmentIntegration( flkty, sliderEl, hasArrows ) {
		// elements
		const parentElement    = sliderEl.parentElement
		const cellsButtonGroup = parentElement.querySelector( '.carousel-dots' )
		const cellsButtons     = utils.makeArray( cellsButtonGroup.children )

		// update buttons on select
		flkty.on( 'select', function () {
			const previousSelectedButton = cellsButtonGroup.querySelector( '.is-selected' )
			const selectedButton         = cellsButtonGroup.children[flkty.selectedIndex]
			previousSelectedButton.classList.remove( 'is-selected' )
			selectedButton.classList.add( 'is-selected' )
		} )
		// cell select
		cellsButtonGroup.addEventListener( 'click', function ( event ) {
			if ( !matchesSelector( event.target, '.dot' ) ) {
				return
			}
			const index = cellsButtons.indexOf( event.target )
			flkty.select( index )
		} )

		if ( hasArrows ) {
			// previous
			parentElement.querySelector( '.button--previous' ).addEventListener( 'click', function () {
				flkty.previous()
			} )
			// next
			parentElement.querySelector( '.button--next' ).addEventListener( 'click', function () {
				flkty.next()
			} )
		}
	}

}
